/* globals $, svgedit */
/* jslint vars: true, eqeq: true, forin: true */
/**
 * Package: svedit.select
 *
 * Licensed under the MIT License
 *
 * Copyright(c) 2010 Alexis Deveria
 * Copyright(c) 2010 Jeff Schiller
 */

// Dependencies:
// 1) jQuery
// 2) browser.js
// 3) math.js
// 4) svgutils.js
import { constants, element } from '@config';

(function () {
  'use strict';

  if (!svgedit.select) {
    svgedit.select = {};
  }

  let canResize;
  let svgFactory_;
  let config_;
  let selectorManager_; // A Singleton
  const gripRadius = svgedit.browser.isTouch()
    ? 15
    : 10;
  const gripRotateSize = 25;

  // Class: svgedit.select.Selector
  // Private class for DOM element selection boxes
  //
  // Parameters:
  // id - integer to internally indentify the selector
  // elem - DOM element associated with this selector
  svgedit.select.Selector = function (id, elem) {
    // this is the selector's unique number
    this.id = id;

    // this holds a reference to the element for which this selector is being used
    this.selectedElement = elem;

    // this is a flag used internally to track whether the selector is being used or not
    this.locked = true;

    this.selectorGutter = 0;

    // this holds a reference to the <g> element that holds all visual elements of the selector
    this.selectorGroup = svgFactory_.createSVGElement({
      element: 'g',
      attr: { id: ('selectorGroup' + this.id) }
    });

    // this holds a reference to the path rect
    this.selectorRect = this.selectorGroup.appendChild(
      svgFactory_.createSVGElement({
        element: 'path',
        attr: {
          id: ('selectedBox' + this.id),
          fill: 'none',
          stroke: '#0BC9F7',
          'stroke-width': '2',
          // need to specify this so that the rect is not selectable
          style: 'pointer-events:none'
        }
      })
    );

    this.highlightRects = [];
    // this holds a reference to the grip coordinates for this selector
    this.gripCoords = {
      nw: null,
      n: null,
      ne: null,
      e: null,
      se: null,
      s: null,
      sw: null,
      w: null
    };

    this.reset(this.selectedElement);
  };

  // Function: svgedit.select.Selector.reset
  // Used to reset the id and element that the selector is attached to
  //
  // Parameters:
  // e - DOM element associated with this selector
  svgedit.select.Selector.prototype.reset = function (e) {
    this.locked = true;
    this.selectedElement = e;
    this.resize();
    $(this.selectorGroup).attr('data-element-id', this.selectedElement.id);
    this.selectorGroup.setAttribute('display', 'inline');
  };

  // Function: svgedit.select.Selector.updateGripCursors
  // Updates cursors for corner grips on rotation so arrows point the right way
  //
  // Parameters:
  // angle - Float indicating current rotation angle in degrees
  svgedit.select.Selector.prototype.updateGripCursors = function (angle) {
    let dir;
    const dirArr = [];
    let steps = Math.round(angle / 45);
    if (steps < 0) {
      steps += 8;
    }
    for (dir in selectorManager_.selectorGrips) {
      dirArr.push(dir);
    }
    while (steps > 0) {
      dirArr.push(dirArr.shift());
      steps--;
    }
    let i = 0;
    for (dir in selectorManager_.selectorGrips) {
      const cursorStyle = $(selectorManager_.selectorGrips[dir])
        .is('.resize-button')
        ? 'default'
        : dirArr[i] + '-resize';

      selectorManager_.selectorGrips[dir].setAttribute('style', ('display: none; cursor:' + cursorStyle));
      i++;
    }

    canResize && toggleSelectionGrips();
    this.handleResizeSelectorVisibility(this.selectedElement);
  };

  svgedit.select.Selector.prototype.updateGripStyle = function (isTable) {
    for (const gripDirection in selectorManager_.selectorGripsSmallNitid) {
      if (['plus', 'minus'].includes(gripDirection)) continue;

      const grip = selectorManager_.selectorGripsSmallNitid[gripDirection];
      grip.classList.remove('gripHovered');
      svgedit.utilities.assignAttributes(grip, {
        fill: isTable ? constants.table.tableGripStyle.fill : constants.colors.gripStyle.fill,
        stroke: isTable ? constants.table.tableGripStyle.stroke : constants.colors.gripStyle.stroke
      });
    }
  };

  // Function: svgedit.select.Selector.showGrips
  // Show the resize grips of this selector
  //
  // Parameters:
  // show - boolean indicating whether grips should be shown or not
  svgedit.select.Selector.prototype.showGrips = function (show) {
    const isTable = !!this.selectedElement?.closest('.table');
    const isTableCell = this.selectedElement?.parentElement?.classList?.contains('table-cell');
    const elem = this.selectedElement;
    const isLocked = $(elem).hasClass('locked');
    let canRotate = INKIVE.RestrictionsFacade.canChange(elem, 'rotation');
    let canMove = INKIVE.RestrictionsFacade.canChange(elem, 'position') ||
      $(elem).hasClass('layoutClipperImage');
    canMove = elem
      ? canMove
      : true;

    this.selectorGutter = 0;

    const strokeColor = getStrokeColor();

    show = isLocked
      ? false
      : show;
    this.selectorRect.setAttribute('stroke', strokeColor);
    if ($(elem).parent().hasClass('background')) {
      show = false;
    }
    // TODO: use suspendRedraw() here
    const bShow = show
      ? 'inline'
      : 'none';
    selectorManager_.selectorGripsGroup.setAttribute('display', bShow);

    this.hasGrips = show;
    if (elem && show) {
      this.selectorGroup.appendChild(selectorManager_.selectorGripsGroup);
      this.updateGripCursors(svgedit.utilities.getRotationAngle(elem));
      this.updateGripStyle(isTable);
    }

    $('.selectorGrip').attr('display', 'inline');
    canResize = isTable
      ? INKIVE.RestrictionsFacade.canChange(elem, 'resize')
      : INKIVE.RestrictionsFacade.canChange(elem, 'size') || $(elem).hasClass('layoutClipperImage');

    canResize = elem
      ? canResize
      : false;

    const tool = INKIVE.Tool.getInstance();
    const canvas = tool.editor.canvas;

    if (canvas.getMode().match('replace-') || $(elem).is('.non-selectable') || isTableCell) {
      canMove = canResize = canRotate = false;
    }

    canResize || $(['#selectorGrip_resize_n',
      '#selectorGrip_resize_s',
      '#selectorGrip_resize_w',
      '#selectorGrip_resize_e',
      '#selectorGrip_resize_ne',
      '#selectorGrip_resize_se',
      '#selectorGrip_resize_sw',
      '#selectorGrip_resize_nw',
      '#selectorGrip_resize_plus',
      '#selectorGrip_resize_minus',
      '.selectorGrip'
    ].join(',')).hide();

    canMove || $('#selectorGrip_move').hide();
    $('#selectorGrip_rotateconnector, #selectorGrip_rotate').toggle(canRotate);
    canResize && toggleSelectionGrips();

    const elementProperties = INKIVE.DesignFacade.get($(elem).attr('id'));

    if (elementProperties) {
      const $gripArrow = $('symbol#arrow').find('polygon');

      (elementProperties.type === 'sticker' || elementProperties.type === 'shape') && $gripArrow.hide();
      (elementProperties.type === 'sticker' || elementProperties.type === 'shape') || $gripArrow.show();
    }

    this.handleResizeSelectorVisibility(elem);
    this.handleSimplifiedPermissions();

    function getStrokeColor () {
      if (isLocked) {
        return '#FF0000';
      } else if (canMove) {
        return (isTable && show) ? 'transparent' : '#0BC9F7';
      }

      return INKIVE.C.WHITE_LABEL_CONFIGURATION.colors.highlight;
    }
  };

  svgedit.select.Selector.prototype.handleResizeSelectorVisibility = function (elem) {
    if ($(elem).is('.textarea')) {
      if (INKIVE.C.BOOK.book_type === INKIVE.C.BOOK_TYPE.RESTRICTED_DESIGN && INKIVE.ProjectFacade.pageInfo?.template) {
        const cornerGrips = ['#selectorGrip_resize_ne', '#selectorGrip_resize_se', '#selectorGrip_resize_sw', '#selectorGrip_resize_nw', '#selectorGrip_resize_s', '#selectorGrip_resize_n'];

        cornerGrips.forEach(cornerGrip => {
          const cornerGripElement = document.querySelector(cornerGrip);
          cornerGripElement.style.display = 'none';
        });

        const selectorGripElements = document.querySelectorAll('.selectorGrip:not(.x-handler)');
        selectorGripElements.forEach(selectorGripElement => {
          selectorGripElement.style.display = 'none';
        });
      }

      if (!elem || elem.querySelector('[class*="columns"]')) {
        return;
      }

      if (!elem.dataset.parent && !elem.dataset.child) {
        $('#selectorGrip_resize_n').hide();
        $('#selectorGrip_resize_s').hide();
        $('.selectorGrip.crop-handler.y-handler').hide();
      }
    } else if (this.isFixedProportion()) {
      $('#selectorGrip_resize_n').hide();
      $('#selectorGrip_resize_s').hide();
      $('#selectorGrip_resize_w').hide();
      $('#selectorGrip_resize_e').hide();
      $('.selectorGrip.crop-handler').hide();
    }
  };

  svgedit.select.Selector.prototype.isFixedProportion = function () {
    if (!this.selectedElement) return true;

    const elementDetails = INKIVE.Helpers.elementHelper(this.selectedElement);
    const hasSubElement = this.selectedElement.querySelector('.layoutBox.subelement');
    const isFixedType = elementDetails.isLogo() || elementDetails.isIcon();
    const isInvalidImage = elementDetails.isImage() && !elementDetails.hasLayoutBox();
    const isInvalidVideo = elementDetails.isVideo() && (!elementDetails.hasLayoutBox() || !this.selectedElement.hasAttribute('clip-path'));
    const isQRCode = elementDetails.isQRCode();
    return isInvalidVideo ||
      isInvalidImage ||
      isFixedType ||
      hasSubElement ||
      isQRCode;
  };

  svgedit.select.Selector.prototype.getSelectionBBox = function () {
    const selected = this.selectedElement;
    let strokedBBox;
    let selectionBBox = svgedit.utilities.getBBox(selected);

    if (selected.tagName === 'g' && $(selected).is('.textarea')) {
      strokedBBox = svgedit.utilities.getStrokedBBox(selected.getElementsByTagName('rect')[0]);
      if (strokedBBox) selectionBBox = strokedBBox;
    } else if (selected.tagName === 'g' && selected.classList.contains('table')) {
      strokedBBox = svgedit.utilities.getStrokedBBox(selected.getElementsByTagName('rect')[0]);
      if (strokedBBox) selectionBBox = strokedBBox;
    } else if (selected.tagName === 'g' && selected.classList.contains('group')) {
      return selectionBBox;
    } else if (selected.tagName === 'g' && !$.data(selected, 'gsvg')) {
      strokedBBox = svgedit.utilities.getStrokedBBox(selected.childNodes);
      if (strokedBBox) selectionBBox = strokedBBox;
    } else if ((selected.tagName === 'image' || INKIVE.Helpers.elementHelper(selected).isVideo()) && INKIVE.Helpers.elementHelper(selected).hasLayoutBox() && selected.hasAttribute('clip-path')) {
      const clipPath = svgedit.utilities.getClipPath(selected);
      strokedBBox = svgedit.utilities.getBBox(clipPath);
      if (strokedBBox) selectionBBox = strokedBBox;
    }

    return selectionBBox;
  };

  svgedit.select.Selector.prototype.getElementRotationAngle = function () {
    const isTableText = this.selectedElement?.parentElement?.classList?.contains('table-cell');

    const element = isTableText ? this.selectedElement.closest('.table') : this.selectedElement;
    return svgedit.utilities.getRotationAngle(element);
  };

  svgedit.select.Selector.prototype.getClipPathRotationAngle = function () {
    const clipPath = svgedit.utilities.getClipPath(this.selectedElement);
    let clipPathAngle = 0;

    if (clipPath) {
      const rect = clipPath.getElementsByTagName('rect')[0] || clipPath.getElementsByTagName('path')[0];
      clipPathAngle = rect && rect.hasAttribute('transform')
        ? svgedit.utilities.getRotationAngle(rect)
        : 0;
    }

    return clipPathAngle;
  };

  svgedit.select.Selector.prototype.getTotalRotationAngle = function () {
    return this.getElementRotationAngle() + this.getClipPathRotationAngle();
  };

  svgedit.select.Selector.prototype.getTransformMatrix = function () {
    const currentZoom = svgFactory_.currentZoom();
    const isTableText = this.selectedElement?.parentElement?.classList?.contains('table-cell');
    const selected = isTableText ? this.selectedElement.closest('.table') : this.selectedElement;
    const totalRotationAngle = this.getTotalRotationAngle();
    const elementRotationAngle = this.getElementRotationAngle();

    const selectedTransformList = svgedit.transformlist.getTransformList(selected);
    let transformList = selectedTransformList;

    if (totalRotationAngle !== elementRotationAngle) {
      transformList = $.extend(true, {}, selectedTransformList);
      for (let i = 0; i < transformList.numberOfItems; i++) {
        const transform = _.clone(transformList.getItem(i));

        // TODO: avoid clip & image simultaneous rotation conflicts
        if (transform.type === 4) {
          transformList.removeItem(i);
        }
      }
    }

    const matrix = svgedit.math.transformListToTransform(transformList).matrix;
    return getUpdatedMatrix();

    function getUpdatedMatrix () {
      _.each('abcdef'.split(''), function (key) {
        matrix[key] *= currentZoom;
      });

      return matrix;
    }
  };

  svgedit.select.Selector.prototype.getTransformBox = function (transformMatrix) {
    const selectionBBox = this.getSelectionBBox();

    return $.extend({ bbox: selectionBBox }, svgedit.math.transformBox(
      selectionBBox.x,
      selectionBBox.y,
      selectionBBox.width,
      selectionBBox.height,
      transformMatrix
    ));
  };

  // Function: svgedit.select.Selector.resize
  // Updates the selector to match the element's size
  svgedit.select.Selector.prototype.resize = function () {
    const currentZoom = svgFactory_.currentZoom();
    const selected = this.selectedElement;
    const offset = getOffset();

    const transformMatrix = this.getTransformMatrix();
    const transformBox = this.getTransformBox(transformMatrix);

    this.highlightRects.forEach(element => element.remove());
    this.highlightRects = [];

    if (selected.classList.contains('textarea')) {
      const spans = selected.querySelectorAll('[data-defined-placeholder],[custom-placeholder]');

      for (let i = 0; i < spans.length; i++) {
        if (!INKIVE.Helpers.isWeBrandTemplate() && !!spans[i].getAttribute('custom-placeholder')) continue;

        const spanBox = spans[i].getBBox();
        const spanTransformBox = svgedit.math.transformBox(
          spanBox.x,
          spanBox.y,
          spanBox.width,
          spanBox.height,
          transformMatrix
        ).aabox;

        const color = spans[i].getAttribute('data-defined-placeholder')
          ? INKIVE.C.WHITE_LABEL_CONFIGURATION.colors.highlight
          : '#0038ff';

        const highlightRect = this.selectorGroup.appendChild(
          svgFactory_.createSVGElement({
            element: 'rect',
            attr: {
              id: ('selectedHighlightRect' + i),
              fill: color,
              opacity: 0.4,
              style: 'pointer-events:none',
              x: spanTransformBox.x - offset,
              y: spanTransformBox.y - offset,
              width: spanTransformBox.width + offset * 2,
              height: spanTransformBox.height + offset * 2
            }
          })
        );

        this.highlightRects.push(highlightRect);
      }
    }

    this.transformBox = transformBox;

    const srHandle = svgFactory_.svgRoot().suspendRedraw(100);

    const aabox = transformBox.aabox;
    let nbax = aabox.x - offset - this.selectorGutter;
    let nbay = aabox.y - offset - this.selectorGutter;
    let nbaw = aabox.width + (offset * 2) + this.selectorGutter;
    let nbah = aabox.height + (offset * 2) + this.selectorGutter;

    // now if the shape is rotated, un-rotate it
    const cx = nbax + nbaw / 2;
    const cy = nbay + nbah / 2;

    if (!selected.classList.contains('highlighted')) {
      selected.classList.add('selected');
    }

    applyAngleTransforms.call(this);
    applyTransformsToElement.call(this);
    applyTransformsToGrip.call(this);

    this.transformBox.abbox = {
      x: nbax,
      y: nbay,
      width: nbaw,
      height: nbah
    };

    svgFactory_.svgRoot().unsuspendRedraw(srHandle);

    function getOffset () {
      const strokeWidth = selected.getAttribute('stroke-width');
      let offset = 0;

      if (selected.getAttribute('stroke') !== 'none' && !isNaN(strokeWidth)) {
        offset += strokeWidth / 2;
      }

      // if(selected.tagName === 'text')
      //   offset += 2 / currentZoom;

      return offset * currentZoom;
    }

    function applyAngleTransforms () {
      const angle = this.getTotalRotationAngle();
      angle && processRotation();
      angle && processAxisAlignedBBox();

      function processRotation () {
        const rotationTransform = svgFactory_.svgRoot().createSVGTransform();
        rotationTransform.setRotate(-angle, cx, cy);

        const rotationTransformMatrix = rotationTransform.matrix;

        transformBox.tl = svgedit.math.transformPoint(transformBox.tl.x, transformBox.tl.y, rotationTransformMatrix);
        transformBox.tr = svgedit.math.transformPoint(transformBox.tr.x, transformBox.tr.y, rotationTransformMatrix);
        transformBox.bl = svgedit.math.transformPoint(transformBox.bl.x, transformBox.bl.y, rotationTransformMatrix);
        transformBox.br = svgedit.math.transformPoint(transformBox.br.x, transformBox.br.y, rotationTransformMatrix);
      }

      function processAxisAlignedBBox () {
        const allXs = [transformBox.tl.x, transformBox.tr.x, transformBox.bl.x, transformBox.br.x];
        const allYs = [transformBox.tl.y, transformBox.tr.y, transformBox.bl.y, transformBox.br.y];

        const minx = _.min(allXs) - offset;
        const miny = _.min(allYs) - offset;
        const maxx = _.max(allXs) + offset;
        const maxy = _.max(allYs) + offset;

        nbax = minx;
        nbay = miny;
        nbaw = maxx - minx;
        nbah = maxy - miny;
      }
    }

    function applyTransformsToElement () {
      const angle = this.getElementRotationAngle();
      const transformAttribute = angle
        ? 'rotate(' + [angle, cx, cy].join(',') + ')'
        : '';

      const pathAttribute = 'M' + nbax + ',' + nbay +
        ' L' + (nbax + nbaw) + ',' + nbay +
        ' ' + (nbax + nbaw) + ',' + (nbay + nbah) +
        ' ' + nbax + ',' + (nbay + nbah) + 'z';

      this.selectorRect.setAttribute('d', pathAttribute);
      this.selectorGroup.setAttribute('transform', transformAttribute);
    }

    function getGripCoords (isTable) {
      const margin = isTable
        ? constants.table.selectorMargin
        : 0;

      return {
        nw: [nbax - margin, nbay - margin],
        ne: [nbax + nbaw + margin, nbay - margin],
        sw: [nbax - margin, nbay + nbah + margin],
        se: [nbax + nbaw + margin, nbay + nbah + margin],
        n: [nbax + (nbaw) / 2, nbay - margin],
        w: [nbax - margin, nbay + (nbah) / 2],
        e: [nbax + nbaw + margin, nbay + (nbah) / 2],
        s: [nbax + (nbaw) / 2, nbay + nbah + margin]
      };
    }

    function applyTransformsToGrip () {
      const selectedGrips = selectorManager_.selectorGrips;
      const selectedGripsSmallNitid = selectorManager_.selectorGripsSmallNitid;
      const zoomControlsPositions = getZoomControlPosition();

      const isTable = !!this.selectedElement?.closest('.table');
      this.gripCoords = getGripCoords(isTable);

      if (zoomControlsPositions) {
        this.gripCoords.plus = zoomControlsPositions.plus;
        this.gripCoords.minus = zoomControlsPositions.minus;
      }

      _.each(this.gripCoords, function (coords, index) {
        const correctionX = index === 'n' || index === 's'
          ? -9
          : -3;
        const correctionY = index === 'n' || index === 's'
          ? -2
          : -9;
        if ($(selectedGrips[index]).is('circle')) {
          selectedGrips[index].setAttribute('cx', coords[0]);
          selectedGrips[index].setAttribute('cy', coords[1]);

          if ($(selectedGripsSmallNitid[index]).is('circle')) {
            selectedGripsSmallNitid[index].setAttribute('cx', coords[0]);
            selectedGripsSmallNitid[index].setAttribute('cy', coords[1]);
          } else {
            selectedGripsSmallNitid[index].setAttribute('x', coords[0] + correctionX);
            selectedGripsSmallNitid[index].setAttribute('y', coords[1] + correctionY);
          }
        } else if ($(selectedGrips[index]).is('.resize-button')) {
          const circle = $(selectedGrips[index]).find('circle');
          const text = $(selectedGrips[index]).find('text');
          const correction = 12.5;

          circle.attr('cx', coords[0] + correction).attr('cy', coords[1] - correction + 1);
          text.attr('x', coords[0]).attr('y', coords[1]);
        } else {
          const factor = gripRadius / 35;

          selectedGrips[index].setAttribute('x', coords[0] - 98 / 2);
          selectedGrips[index].setAttribute('y', coords[1] - 95.33 / 2);

          if ($(selectedGripsSmallNitid[index]).is('circle')) {
            selectedGripsSmallNitid[index].setAttribute('cx', coords[0]);
            selectedGripsSmallNitid[index].setAttribute('cy', coords[1]);
          } else {
            selectedGripsSmallNitid[index].setAttribute('x', coords[0] + correctionX);
            selectedGripsSmallNitid[index].setAttribute('y', coords[1] + correctionY);
          }

          const cdx = -coords[0] * (factor - 1);
          const cdy = -coords[1] * (factor - 1);
          let transform = 'translate(' + cdx + ',' + cdy + ') scale(' + factor + ')';

          const id = selectedGrips[index].getAttribute('id');
          if (/resize_s/.test(id)) {
            transform += ' rotate(90 ' + coords[0] + ' ' + coords[1] + ')';
          } else if (/resize_w/.test(id)) {
            transform += ' rotate(180 ' + coords[0] + ' ' + coords[1] + ')';
          } else if (/resize_n/.test(id)) {
            transform += ' rotate(-90 ' + coords[0] + ' ' + coords[1] + ')';
          }

          selectedGrips[index].setAttribute('transform', transform);
        }

        if (index === 'ne' && selectorManager_.lockGrip) {
          const grip = selectorManager_.lockGrip.querySelector('use');

          grip.setAttribute('x', (coords[0] - 5.5));
          grip.setAttribute('y', (coords[1] - 5.5));
        }
      });

      // we want to go 20 pixels in the negative transformed y direction, ignoring scale
      selectorManager_.rotateGripConnector.setAttribute('x1', nbax + nbaw / 2);
      selectorManager_.rotateGripConnector.setAttribute('y1', nbay + nbah);
      selectorManager_.rotateGripConnector.setAttribute('x2', nbax + nbaw / 2);
      selectorManager_.rotateGripConnector.setAttribute('y2', nbay + nbah + gripRadius * 2.5);

      setTranformIconPosition(selectorManager_.rotateGrip);

      // we want to go 20 pixels in the negative transformed y direction, ignoring scale
      selectorManager_.moveGripConnector.setAttribute('x1', nbax + nbaw / 2);
      selectorManager_.moveGripConnector.setAttribute('y1', nbay + nbah);
      selectorManager_.moveGripConnector.setAttribute('x2', nbax + nbaw / 2);
      selectorManager_.moveGripConnector.setAttribute('y2', nbay + nbah + gripRadius * 2.5);

      setTranformIconPosition(selectorManager_.moveGrip);

      canResize && toggleSelectionGrips();
      this.handleResizeSelectorVisibility(this.selectedElement);

      INKIVE.RestrictionsFactory && applyTransformsToRestrictions();

      function setTranformIconPosition (icon) {
        const circle = $(icon).find('circle');
        const text = $(icon).find('text');
        const radius = circle.attr('r');
        const isMoveGrip = icon.getAttribute('id') === 'selectorGrip_move';
        let shift = 0;

        if (isTable) {
          shift = isMoveGrip ? radius + constants.table.selectorMargin : -radius - constants.table.selectorMargin;
        }

        circle.attr('cx', nbax + nbaw / 2 + shift).attr('cy', nbay + nbah + radius * 3);
        text.attr('x', nbax + nbaw / 2 - gripRotateSize / 2 + shift).attr('y', nbay + nbah + gripRotateSize * 2 - 1);
      }

      function getZoomControlPosition () {
        const initialPosition = gripRotateSize / 4;
        const margin = 30;

        const validPosition = {
          plus: [nbax + nbaw + margin / 2, nbay + initialPosition],
          minus: [nbax + nbaw + margin / 2, nbay + initialPosition * 2 + margin]
        };

        const $svgContent = $('#svgcontent');
        const canvasWidth = $svgContent.attr('width') * currentZoom;
        const canvasHeight = $svgContent.attr('height') * currentZoom;

        if (overflowsLeft()) {
          validPosition.plus[0] = validPosition.minus[0] = 0;
        } else if (overflowsRight()) {
          validPosition.plus[0] = validPosition.minus[0] = canvasWidth - initialPosition;
        }

        if (overflowsTop()) {
          validPosition.plus[1] = initialPosition;
          validPosition.minus[1] = margin + initialPosition * 2;
        } else if (overflowsBottom()) {
          validPosition.plus[1] = canvasHeight - initialPosition;
          validPosition.minus[1] = canvasHeight - initialPosition * 2 + margin + 10;
        }

        return validPosition;

        function overflowsLeft () {
          return validPosition.plus[0] < 0;
        }

        function overflowsRight () {
          return validPosition.plus[0] + initialPosition > canvasWidth;
        }

        function overflowsTop () {
          return validPosition.plus[1] < initialPosition;
        }

        function overflowsBottom () {
          return validPosition.plus[1] + initialPosition > canvasHeight;
        }
      }
    }

    function applyTransformsToRestrictions () {
      let line;
      const marginBox = $('#margin-box')[0];
      const tool = INKIVE.Tool.getInstance();
      const svgCanvas = tool.editor.canvas;

      if (marginBox) {
        const margin = parseFloat(marginBox.getAttribute('stroke-width'));
        svgCanvas.assignAttributes(marginBox, {
          width: nbaw + margin,
          height: nbah + margin,
          x: nbax - (margin / 2),
          y: nbay - (margin / 2)
        });
      }

      // TODO: invert rotation
      line = $('#vertical-line')[0];
      line && svgCanvas.assignAttributes(line, {
        x1: nbax + nbaw / 2,
        y1: nbay,
        x2: nbax + nbaw / 2,
        y2: nbay + nbah
      });

      line = $('#horizontal-line')[0];
      line && svgCanvas.assignAttributes(line, {
        x1: nbax,
        y1: nbay + nbah / 2,
        x2: nbax + nbaw,
        y2: nbay + nbah / 2
      });
    }
  };

  svgedit.select.Selector.prototype.handleSimplifiedPermissions = function () {
    selectorManager_.lockGrip && (selectorManager_.lockGrip.style.display = 'none');
    if (!INKIVE.Menus.showSimplifiedRestrictions || !this.selectedElement || INKIVE.C.IS_MOBILE) {
      return;
    }

    INKIVE.RestrictionsFactory.getElementPermissions().then((permissions) => {
      if (permissions.find((p) => p.element_id === this.selectedElement.id && p.page_number === INKIVE.Tool._current_page_number)) {
        this.selectorRect.setAttribute('stroke', '#FF6565');

        if (!selectorManager_.lockGrip) {
          selectorManager_.lockGrip = svgFactory_.createSVGElement({
            element: 'g',
            attr: {
              id: 'selectorGrip_lock',
              style: 'cursor: move;',
              'pointer-events': 'none'
            }
          });

          const use = svgFactory_.createSVGElement({
            element: 'use',
            attr: {
              'xlink:href': '#key',
              width: 11,
              height: 11
            }
          });

          selectorManager_.lockGrip.appendChild(use);
          this.selectorGroup.querySelector('g').appendChild(selectorManager_.lockGrip);
        }
        selectorManager_.lockGrip.style.display = '';
      }
    });
  };

  // Class: svgedit.select.SelectorManager
  svgedit.select.SelectorManager = function () {
    // this will hold the <g> element that contains all selector rects/grips
    this.selectorParentGroup = null;

    // this is a special rect that is used for multi-select
    this.rubberBandBox = null;

    // this will hold objects of type svgedit.select.Selector (see above)
    this.selectors = [];

    // this holds a map of SVG elements to their Selector object
    this.selectorMap = {};

    // this holds a reference to the grip elements
    this.selectorGrips = {
      nw: null,
      n: null,
      ne: null,
      e: null,
      se: null,
      s: null,
      sw: null,
      w: null,
      plus: null,
      minus: null
    };

    this.selectorGripsSmallNitid = {};

    this.selectorGripsGroup = null;
    this.rotateGripConnector = null;
    this.rotateGrip = null;
    this.moveGripConnector = null;
    this.moveGrip = null;

    this.initGroup();
  };

  svgedit.select.SelectorManager.prototype.createDropShadowFilter = function () {
    const svgpanel = document.getElementById('svgpanel');
    const defs = document.createElementNS(window.NAMESPACE_URIS.SVG, 'defs');
    const filter = document.createElementNS(window.NAMESPACE_URIS.SVG, 'filter');
    filter.setAttribute('id', 'dropshadow');
    filter.setAttribute('width', '1000%');
    filter.setAttribute('height', '1000%');
    filter.setAttribute('filterUnits', 'userSpaceOnUse');

    const gaussianFilter = document.createElementNS(window.NAMESPACE_URIS.SVG, 'feGaussianBlur');
    gaussianFilter.setAttribute('in', 'SourceAlpha');
    gaussianFilter.setAttribute('stdDeviation', '3');

    filter.appendChild(gaussianFilter);

    const feMerge = document.createElementNS(window.NAMESPACE_URIS.SVG, 'feMerge');
    filter.appendChild(feMerge);

    const feMergeNode = document.createElementNS(window.NAMESPACE_URIS.SVG, 'feMergeNode');
    feMerge.appendChild(feMergeNode);

    const feMergeNode2 = document.createElementNS(window.NAMESPACE_URIS.SVG, 'feMergeNode');
    feMergeNode2.setAttribute('in', 'SourceGraphic');

    feMerge.appendChild(feMergeNode2);

    defs.appendChild(filter);
    svgpanel.appendChild(defs);
  };

  // Function: svgedit.select.SelectorManager.initGroup
  // Resets the parent selector group element
  svgedit.select.SelectorManager.prototype.initGroup = function () {
    // remove old selector parent group if it existed
    if (this.selectorParentGroup && this.selectorParentGroup.parentNode) {
      this.selectorParentGroup.parentNode.removeChild(this.selectorParentGroup);
    }

    // create parent selector group and add it to svgroot
    this.selectorParentGroup = svgFactory_.createSVGElement({
      element: 'g',
      attr: {
        id: 'selectorParentGroup',
        style: 'pointer-events:auto'
      }
    });
    this.selectorGripsGroup = svgFactory_.createSVGElement({
      element: 'g',
      attr: { display: 'none' }
    });
    $('#dropshadow').length || this.createDropShadowFilter();

    this.selectorParentGroup.appendChild(this.selectorGripsGroup);
    svgFactory_.svgPanel().appendChild(this.selectorParentGroup);

    this.selectorMap = {};
    this.selectors = [];
    this.rubberBandBox = null;

    const dims = config_.dimensions;
    const style = config_.initBackground;
    const iconContent = {
      rotate: '&#xe95a;',
      move: '&#xe95b;',
      plus: '&#xe95c;',
      minus: '&#xe95d;'
    };

    // add rotator elems
    this.rotateGripConnector = this.selectorGripsGroup.appendChild(
      svgFactory_.createSVGElement({
        element: 'line',
        attr: {
          id: 'selectorGrip_rotateconnector',
          fill: '#fff',
          stroke: '#333',
          'stroke-width': 1,
          'stroke-dasharray': '5,5',
          style: 'display:none; pointer-events:none'
        }
      })
    );

    // add move handler
    this.moveGripConnector = this.selectorGripsGroup.appendChild(
      svgFactory_.createSVGElement({
        element: 'line',
        attr: {
          id: 'selectorGrip_moveconnector',
          fill: '#fff',
          stroke: '#333',
          'stroke-width': 1,
          'stroke-dasharray': '5,5',
          style: 'display:none; pointer-events:none;cursor: default;'
        }
      })
    );

    // add the corner grips
    for (const dir in this.selectorGrips) {
      let grip = null;
      let grip3 = null;

      if (_.contains(['plus', 'minus'], dir)) {
        grip = createTransformGrip(dir, 'resize-button', true);
      } else {
        if (_.contains(['e', 'w', 'n', 's'], dir)) {
          const isY = _.contains(['n', 's'], dir);

          grip3 = svgFactory_.createSVGElement({
            element: 'rect',
            attr: {
              class: 'selectorGrip crop-handler ' + (isY
                ? 'y-handler'
                : 'x-handler'),
              fill: constants.colors.gripStyle.fill,
              width: isY
                ? 17
                : 6,
              height: isY
                ? 6
                : 17,
              rx: 4,
              ry: 4,
              stroke: constants.colors.gripStyle.stroke,
              strokeWidth: 1.5
            }
          });

          grip = svgFactory_.createSVGElement({
            element: 'use',
            attr: {
              id: ('selectorGrip_resize_' + dir),
              'xlink:href': '#arrow',
              style: ('display: none; cursor:' + dir + '-resize'),
              'pointer-events': 'all'
            }
          });
        } else {
          grip3 = svgFactory_.createSVGElement({
            element: 'circle',
            attr: {
              class: 'selectorGrip',
              fill: constants.colors.gripStyle.fill,
              r: 7,
              stroke: constants.colors.gripStyle.stroke,
              strokeWidth: 2
            }
          });

          grip = svgFactory_.createSVGElement({
            element: 'circle',
            attr: {
              id: ('selectorGrip_resize_' + dir),
              fill: 'none',
              r: gripRadius,
              style: ('cursor:' + dir + '-resize'),
              'pointer-events': 'all'
            }
          });
        }

        this.selectorGripsSmallNitid[dir] = this.selectorGripsGroup.appendChild(grip3);
      }

      $.data(grip, 'dir', dir);
      $.data(grip, 'type', 'resize');
      this.selectorGrips[dir] = this.selectorGripsGroup.appendChild(grip);

      if (grip3) {
        grip.addEventListener('mouseover', () => grip3.classList.add('gripHovered'));
        grip.addEventListener('mouseleave', () => grip3.classList.remove('gripHovered'));
      }
    }

    this.rotateGrip = this.selectorGripsGroup.appendChild(createTransformGrip('rotate'));
    this.moveGrip = this.selectorGripsGroup.appendChild(createTransformGrip('move', 'resize-button'));

    if ($('#canvasBackground').length) { return; }

    const canvasbg = svgFactory_.createSVGElement({
      element: 'svg',
      attr: {
        id: 'canvasBackground',
        width: dims[0],
        height: dims[1],
        x: 0,
        y: 0,
        overflow: (svgedit.browser.isWebkit()
          ? 'none'
          : 'visible'), // Chrome 7 has a problem with this when zooming out
        style: 'pointer-events:none'
      }
    });
    let bg;
    if (style.url) {
      bg = svgFactory_.createSVGElement({
        element: 'image',
        attr: {
          class: 'background',
          width: '100%',
          height: '100%',
          x: 0,
          y: 0,
          'xlink:href': style.url,
          style: 'pointer-events:none'
        }
      });
    } else {
      bg = svgFactory_.createSVGElement({
        element: 'rect',
        attr: {
          class: 'background',
          width: '100%',
          height: '100%',
          x: 0,
          y: 0,
          'stroke-width': 1,
          stroke: style.stroke,
          fill: style.fill,
          style: 'pointer-events:none'
        }
      });
    }

    function createTransformGrip (type, className, isResize) {
      className = className || '';
      const g = svgFactory_.createSVGElement({
        element: 'g',
        attr: {
          id: 'selectorGrip_' + (isResize
            ? 'resize_'
            : '') + type,
          class: className,
          style: 'display:none; cursor: move;',
          'pointer-events': 'all'
        }
      });

      g.appendChild(svgFactory_.createSVGElement({
        element: 'circle',
        attr: {
          class: className + ' shadow',
          fill: '#FFFFFF',
          r: gripRotateSize / 2
        }
      }));

      g.appendChild(svgFactory_.createSVGElement({
        element: 'circle',
        attr: {
          class: className,
          fill: '#FFFFFF',
          r: gripRotateSize / 2 + 2
        }
      }));

      const text = svgFactory_.createSVGElement({
        element: 'text',
        attr: {
          'font-family': 'desygner-icons',
          'font-size': gripRotateSize
        }
      });

      $.data(text, 'type', type);
      $(text).html(iconContent[type]);
      g.appendChild(text);

      return g;
    }

    // Both Firefox and WebKit are too slow with this filter region (especially at higher
    // zoom levels) and Opera has at least one bug
    //  if (!svgedit.browser.isOpera()) rect.setAttribute('filter', 'url(#canvashadow)');
    canvasbg.appendChild(bg);
    svgFactory_.svgRoot().insertBefore(canvasbg, svgFactory_.svgContent());
  };

  // Function: svgedit.select.SelectorManager.requestSelector
  // Returns the selector based on the given element
  //
  // Parameters:
  // elem - DOM element to get the selector for
  svgedit.select.SelectorManager.prototype.requestSelector = function (elem) {
    if (elem == null) { return null; }
    let i;
    const N = this.selectors.length;
    // If we've already acquired one for this element, return it.
    if (typeof (this.selectorMap[elem.id]) === 'object') {
      this.selectorMap[elem.id].locked = true;
      return this.selectorMap[elem.id];
    }
    for (i = 0; i < N; ++i) {
      if (this.selectors[i] && !this.selectors[i].locked) {
        this.selectors[i].locked = true;
        this.selectors[i].reset(elem);
        this.selectorMap[elem.id] = this.selectors[i];
        return this.selectors[i];
      }
    }
    // if we reached here, no available selectors were found, we create one
    this.selectors[N] = new svgedit.select.Selector(N, elem);
    this.selectorParentGroup.appendChild(this.selectors[N].selectorGroup);
    this.selectorMap[elem.id] = this.selectors[N];
    return this.selectors[N];
  };

  svgedit.select.SelectorManager.prototype.findSelectorByElement = function (element) {
    return this.selectors.find(selector => selector.selectedElement === element);
  };

  // Function: svgedit.select.SelectorManager.releaseSelector
  // Removes the selector of the given element (hides selection box)
  //
  // Parameters:
  // elem - DOM element to remove the selector for
  svgedit.select.SelectorManager.prototype.releaseSelector = function (elem) {
    if (elem == null) { return; }
    let i;
    const N = this.selectors.length;
    const sel = this.selectorMap[elem.id];
    for (i = 0; i < N; ++i) {
      if (this.selectors[i] && this.selectors[i] === sel) {
        $(elem).removeClass('selected');
        $(elem).contents().each(function () {
          $(this).is('.subelement.active') && $(this).removeClass('active');
        });

        if (sel.locked === false) {
          // TODO(codedread): Ensure this exists in this module.
          if (INKIVE.C.DEBUG) console.log('WARNING! selector was released but was already unlocked');
        }

        delete this.selectorMap[elem.id];
        sel.locked = false;
        sel.selectedElement = null;
        sel.showGrips(false);

        // remove from DOM and store reference in JS but only if it exists in the DOM
        try {
          sel.selectorGroup.setAttribute('display', 'none');
        } catch (e) { }

        break;
      }
    }
  };

  svgedit.select.SelectorManager.prototype.releaseAllSelectors = function () {
    _.each(this.selectors, function (selector) {
      this.releaseSelector(selector.selectedElement);
    }, this);
  };

  // Function: svgedit.select.SelectorManager.getRubberBandBox
  // Returns the rubberBandBox DOM element. This is the rectangle drawn by the user for selecting/zooming
  svgedit.select.SelectorManager.prototype.getRubberBandBox = function () {
    if (!this.rubberBandBox) {
      this.rubberBandBox = this.selectorParentGroup.appendChild(
        svgFactory_.createSVGElement({
          element: 'rect',
          attr: {
            id: 'selectorRubberBand',
            fill: '#2222CC',
            'fill-opacity': 0.15,
            stroke: '#2222CC',
            'stroke-width': 1.0,
            display: 'none',
            style: 'pointer-events:none'
          }
        })
      );
    }
    return this.rubberBandBox;
  };

  /**
   * Interface: svgedit.select.SVGFactory
   * An object that creates SVG elements for the canvas.
   *
   * interface svgedit.select.SVGFactory {
   *   SVGElement createSVGElement(jsonMap);
   *   SVGSVGElement svgRoot();
   *   SVGSVGElement svgContent();
   *
   *   Number currentZoom();
   *   Object getStrokedBBox(Element[]); // TODO(codedread): Remove when getStrokedBBox() has been put into svgutils.js
   * }
   */

  /**
   * Function: svgedit.select.init()
   * Initializes this module.
   *
   * Parameters:
   * config - an object containing configurable parameters (imgPath)
   * svgFactory - an object implementing the SVGFactory interface (see above).
   */
  svgedit.select.init = function (config, svgFactory) {
    config_ = config;
    svgFactory_ = svgFactory;
    selectorManager_ = new svgedit.select.SelectorManager();
  };

  /**
   * Function: svgedit.select.getSelectorManager
   *
   * Returns:
   * The SelectorManager instance.
   */
  svgedit.select.getSelectorManager = function () {
    return selectorManager_;
  };

  svgedit.select.Selector.prototype.toggleSelectorRect = function (show) {
    this.selectorRect.style.display = show ? 'block' : 'none';
  };

  svgedit.select.Selector.prototype.fadeSelectionGrips = function (show, isResize = false) {
    // Causes out of memory error on iOS
    if (INKIVE.C.IS_MOBILE) return;

    const tool = INKIVE.Tool.getInstance();
    const canvas = tool.editor.canvas;
    const gripElements = document.querySelectorAll('.selectorGrip, .resize-button, #selectorGrip_rotate, #selectorGrip_rotateconnector, #selectorGrip_lock');

    if (this.isFixedProportion()) {
      const cropHandler = document.querySelector('.selectorGrip.crop-handler');
      cropHandler.style.display = 'none';
    }

    gripElements.forEach(function (element) {
      element.style.opacity = show ? '1' : '0';
    });

    if (isResize) {
      const currentResizeGrip = selectorManager_.selectorGripsSmallNitid[canvas.current_resize_mode];
      currentResizeGrip.style.opacity = '1';
      currentResizeGrip.classList.toggle('gripHovered', !show);
    }
  };

  function toggleSelectionGrips () {
    const tool = INKIVE.Tool.getInstance();
    const canvas = tool.editor.canvas;
    const selected = canvas.getSelectedElems()[0];
    const shadowGrips = $('#selectorParentGroup').find('.shadow').attr('filter', '');
    const isTable = !!selected?.closest('.table');
    const isTableCell = selected?.parentElement?.classList?.contains('table-cell');

    const selectorGrips = selectorManager_.selectorGrips;
    const ignoreOrtogonal = !!$('#layoutScreen').length;

    const islayoutClipperImage = $(selected).hasClass('layoutClipperImage');
    const canRotate = !islayoutClipperImage && INKIVE.RestrictionsFacade.canChange(selected, 'rotation');

    const $nw = $(selectorGrips.nw);
    const $ne = $(selectorGrips.ne);
    const $sw = $(selectorGrips.sw);

    const nwSize = $nw.attr('r') * 2 + $nw.attr('stroke-width') * 2;
    let hideSelectionGrips = (
      $ne.attr('cx') <= $nw.attr('cx') + nwSize ||
      $sw.attr('cy') <= $nw.attr('cy') + nwSize
    );

    $('#selectorGrip_rotateconnector').toggle(canRotate && !isTable);
    $('#selectorGrip_rotate').toggle(!hideSelectionGrips && canRotate);
    $('#selectorGrip_move').toggle(hideSelectionGrips || (isTable && !isTableCell));

    hideSelectionGrips = hideSelectionGrips && INKIVE.C.IS_MOBILE;

    _.each(selectorGrips, function (selectionGrip, i) {
      if (!ignoreOrtogonal || ['n', 's', 'e', 'w'].indexOf(i) === -1) {
        if ($(selectionGrip).is('.resize-button')) {
          $(selectionGrip).toggle(hideSelectionGrips);
        } else {
          $(selectionGrip).toggle(!hideSelectionGrips);
          $(selectorManager_.selectorGripsSmallNitid[i]).toggle(!hideSelectionGrips);
        }
      }
    });
    shadowGrips.attr('filter', 'url(#dropshadow)');
  }
}());
